export const SITE_PERFORMANCE_CHART_COLUMN_LABEL_ONE = 'operatingHoursComparisonChart.actual';
export const SITE_PERFORMANCE_CHART_COLUMN_LABEL_TWO = 'operatingHoursComparisonChart.planned';

export const SITE_PERFORMANCE_CHART_PAGE_SIZE = 10;
export const SITE_PERFORMANCE_CHART_JS_Y_AXIS_WIDTH = 80;
export const SITE_PERFORMANCE_CHART_Y_AXIS_LABEL_PADDING = 8;
export const SITE_PERFORMANCE_CHART_Y_AXIS_LEFT_TICK_LENGTH = 6;
export const SITE_PERFORMANCE_CHART_BAR_HEIGHT = 20;
export const SITE_PERFORMANCE_CHART_INTRA_SITE_GAP = 4;
export const SITE_PERFORMANCE_CHART_INTER_SITE_GAP = 8;
export const SITE_PERFORMANCE_CHART_JS_LAYOUT_PADDING_TOP = 5;
export const SITE_PERFORMANCE_CHART_Y_AXIS_MAX_CHARS_PER_LINE = 14;

export const SPRING_MASS = 1;
export const SPRING_STIFFNESS = 210;
export const SPRING_DAMPING = 30;
export const MOTION_SETTLE_THRESHOLD = 0.5;

export const TOOLTIP_CURSOR_OFFSET = 12;

export const DEVIATION_ROW_ID = 'deviation';

export const BAR_LABEL_GAP = 8;
export const FULL_WIDTH_BAR_THRESHOLD = 2;
export const SITE_PERFORMANCE_CHART_UNHOVERED_BAR_VALUE_LABEL_COLOR = 'rgba(22, 22, 22, 0.5)';
